import React from "react";

function MobileNav() {

  return (
    <nav
      className="block md:block md:flex md:items-center w-full md:w-auto h-screen"
    >
      <div className="border-b border-gray-400"></div>
      {[
        {
          route: `/`,
          title: `Product`,
        },
        {
          route: `/`,
          title: `Resources`,
        },
        {
          route: `/`,
          title: `Pricing`,
        },
      ].map((link) => (
        <button
          className="block font-semibold py-4 no-underline mx-auto md:mt-0 font-medium 
      text-gray-700 hover:text-gray-900 transition duration-150 ease-in-out focus:outline-none
      border-b border-gray-400 w-full"
          key={link.title}
        >
          {link.title}
        </button>
      ))}
      <button
        className="block no-underline w-5/6 mt-4 mx-auto font-semibold text-lg px-6 py-2 
            rounded bg-yellow-500 hover:bg-yellow-600 transition duration-150 ease-in-out focus:outline-none"
      >
        Login
      </button>
    </nav>
  )
}

export default MobileNav;